<div class="modal-header">
  <h4 class="modal-title">Create Jira Ticket</h4>
  <span type="mode" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </span>
</div>
<div class="modal-body">
  <myp-inline-loader [loading]="loading" height="200px" spinnerName="addEditPreviousVersionLoader"></myp-inline-loader>

  @if (!loading && data) {
    <div>
      <div class="form-group m-t-20">
        <label class="control-label" for="summary">Summary</label>
        <input ngbAutofocus type="text" name="summary" id="summary" [(ngModel)]="data.summary" class="form-control" />
      </div>
      <div class="form-group m-t-20">
        <label class="control-label" for="description">{{ "profile.edit.description" | translate }}</label>
        <textarea class="form-control" rows="15" [(ngModel)]="data.description" id="description"></textarea>
        <span class="text-muted">
          Note: Content from the post has been converted to
          <a href="https://www.markdownguide.org/cheat-sheet/" target="_blank">Markdown</a>
          , which Jira supports in its ticket descriptions.
        </span>
      </div>
      @if (attachments) {
        <div class="form-group m-t-20">
          <label class="control-label">Attached Files</label>
          <div class="d-flex flex-wrap">
            @for (attachment of attachments; track attachment) {
              @if (workspaceService.imageFiles[attachment.extension]) {
                <img [src]="attachment.url" class="m-r-10 m-b-10" style="height: 100px" />
              }
              @if (!workspaceService.imageFiles[attachment.extension]) {
                <div class="generic-file-attachment">
                  {{ attachment.filename }}
                </div>
              }
            }
          </div>
        </div>
      }
      <div class="form-group m-t-20">
        <label class="control-label" for="project">Project (SO, PRS...)</label>
        <select class="form-control" [(ngModel)]="data.project">
          @for (project of jiraProjects; track project) {
            <option [value]="project">{{ project }}</option>
          }
        </select>
      </div>
      <div class="form-group m-t-20">
        <label class="control-label" for="win_url">Type</label>
        <select class="form-control" [(ngModel)]="data.type" [disabled]="!data.project">
          @if (["PRS", "SO"].includes(data.project)) {
            <option value="Story">Story</option>
          }
          @if (["PRS", "SO"].includes(data.project)) {
            <option value="Task">Task</option>
          }
          <option value="Bug">Bug</option>
          @if (data.project !== "PRS") {
            <option value="Improvement">Improvement</option>
          }
          @if (data.project !== "PRS") {
            <option value="New Feature">New Feature</option>
          }
        </select>
      </div>
      <div class="form-group m-t-20">
        <label class="control-label" for="win_url">Priority</label>
        <select class="form-control" [(ngModel)]="data.priority">
          <option value="Highest (P1)">Highest (P1)</option>
          <option value="High (P2)">High (P2)</option>
          <option value="Medium (P3)">Medium (P3)</option>
          <option value="Low (P4)">Low (P4)</option>
        </select>
      </div>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" [disabled]="loading" class="btn btn-primary" (click)="submit()">
    <span>Submit</span>
  </button>
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
